exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vdp-datepicker[data-v-ae3a65d6] {\n  width: 200px !important;\n}\n.mt-50[data-v-ae3a65d6] {\n  margin-top: 50px;\n}\n", ""]);

// exports
